import EventEmitter from "./event-emitter";
export default new EventEmitter();
